export const DefinitionsTypes = {
  SHOW_STAFF: "SHOW_STAFF",
  ADD_STAFF: "ADD_STAFF",
  UPDATE_STAFF: "UPDATE_STAFF",
  DELETE_STAFF: "DELETE_STAFF",
};
